"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollIndicator = void 0;
exports.view = view;
var unit_1 = require("../../unit");
var mithril_1 = require("../mithril");
exports.RollIndicator = { view: view };
function view(dc, ctx) {
    var radius = ctx.height * ctx.zoomLevel / 2;
    var rectWidth = ctx.width * ctx.zoomLevel; // Full width
    // Use pythagorean theorem to get the height offset where the circle's
    // edge will touch the top of the image (which is to be offsetted/scaled later).
    var rectHeight = radius - Math.sqrt((radius * radius) - (rectWidth / 2 * rectWidth / 2));
    var centerHeight = ctx.height * ctx.zoomLevel / 2;
    var centerWidth = ctx.width * ctx.zoomLevel / 2;
    var arcDegrees = 96; // Display graduations over an arc this wide
    var graduationDegrees = 5; // The number of degrees between graduations
    var rollDegrees = unit_1.IkeUnit.convert(ctx.roll, unit_1.IkeUnit.DEGREE, unit_1.IkeUnit.RADIAN);
    var rollText = rollDegrees.toFixed(1) + '°';
    var graduations = [];
    for (var i = -180; i <= 180; i += graduationDegrees) {
        graduations.push({ degrees: i });
    }
    // Display the graduations within `arcDegrees` around the `roll` value
    graduations = graduations.filter(function (grad) { return Math.abs(grad.degrees - rollDegrees) <= arcDegrees / 2; });
    var graduationLength = 25 * ctx.zoomLevel; // The length of each graduation's rendered line
    var indicatorElements = [];
    var degreesElements = [];
    // Arc
    indicatorElements.push((0, mithril_1.m)('path', {
        d: "M 0 ".concat(rectHeight, " A ").concat(radius, " ").concat(radius, " 0 0 1 ").concat(rectWidth, " ").concat(rectHeight),
        stroke: 'white',
        'stroke-width': '8px',
        'fill-opacity': '0'
    }));
    //degree text
    degreesElements.push((0, mithril_1.m)('text', {
        x: centerWidth,
        y: centerHeight,
        transform: "translate(0, ".concat(-radius + graduationLength + (65 * ctx.zoomLevel), ")"),
        fill: 'white',
        'font-size': "".concat(60 * ctx.zoomLevel, "px"),
        'text-anchor': 'middle'
    }, rollText));
    //roll arrow tick left
    degreesElements.push((0, mithril_1.m)('path', {
        d: "M ".concat(centerWidth, " ").concat(centerHeight - radius, " l ").concat(graduationLength, " 0"),
        stroke: 'white',
        'stroke-width': 8 + 'px',
        transform: 'rotate(45)',
        'transform-origin': "".concat(centerWidth, " ").concat(centerHeight - radius)
    }));
    //roll arrow tick right
    degreesElements.push((0, mithril_1.m)('path', {
        d: "M ".concat(centerWidth, " ").concat(centerHeight - radius, " l ").concat(graduationLength, " 0"),
        stroke: 'white',
        'stroke-width': 8 + 'px',
        transform: 'rotate(135)',
        'transform-origin': "".concat(centerWidth, " ").concat(centerHeight - radius)
    }));
    indicatorElements.push((0, mithril_1.m)('g', degreesElements));
    indicatorElements.push.apply(indicatorElements, graduations.map(function (grad) { return (0, mithril_1.m)('g', [
        // Graduation degree label
        (0, mithril_1.m)('g', {
            transform: "rotate(".concat(grad.degrees - rollDegrees, ")"),
            'transform-origin': "".concat(centerWidth, " ").concat(centerHeight)
        }, (0, mithril_1.m)('text', {
            x: centerWidth,
            y: centerHeight,
            transform: "translate(0, ".concat(-radius - 13, ")"),
            fill: 'white',
            'font-size': "".concat(50 * ctx.zoomLevel, "px"),
            'text-anchor': 'middle'
        }, "".concat(grad.degrees))),
        // Graduation line
        (0, mithril_1.m)('path', {
            d: "M ".concat(centerWidth, " ").concat(centerHeight, " l ").concat(graduationLength, " 0"),
            stroke: 'white',
            'stroke-width': Math.round(8 * ctx.zoomLevel) + 'px',
            transform: "rotate(".concat(grad.degrees - 90 - rollDegrees, ") translate(").concat(radius - graduationLength, ")"),
            'transform-origin': "".concat(centerWidth, " ").concat(centerHeight)
        })
    ]); }));
    return (0, mithril_1.m)('g', {
        className: 'c-Draw-rollindicator',
        transform: "scale(".concat(ctx.scale / 4, ") translate(0, ").concat((ctx.resHeight * 0.05) * ctx.zoomLevel, ")"),
        filter: 'drop-shadow(0 0 10px black)',
        'pointer-events': 'none'
    }, indicatorElements);
}
//# sourceMappingURL=rollIndicator.js.map